import createApi from 'api/createApi';
import serverApi from 'api/sn/server';

export const tags = {
	applications: 'data/applications',
};

export const dataApi = createApi({
	reducerPath: 'dataApi',

	endpoints: (builder) => ({
		applications: builder.mutation({
			query: () => ({
				method: 'GET',
				url: '/data/applications.json',
			}),
			providesTags: [tags.applications],
		}),
	}),
});

export const {
	applications,
} = dataApi.endpoints;

export default dataApi;